export const STEPS = {
  'START': 0,
  'SETTING': 1,
  // 'RICH_CONTENT': 2,
  // 'SELECT_COMPETITORS': 3,
  'SEARCH_ENGINE_TITLE':4,
  'PAGE_TITLE': 5,
  'SUBHEADINGS': 6,
  'PARAGRAPH': 7,
};


export const STPES_LABEL = {
  0: '', // 0
  1: 'Configuration', // 1
  2: 'Rich content', // 2
  3: 'Customization', // 3
  4: 'Search engine title', // 4
  5: 'Page title', // 5
  6: 'Sub-headings', // 6
  7: 'Main content', // 7
}

export const STPES_LONGER_LABEL = {
  0: '', // 0
  1: 'Article configuration', // 1
  2: 'Rich content', // 2
  3: 'Customization', // 3
  4: 'Search engine title', // 4
  5: 'Page title', // 5
  6: 'H2 and H3 sub-headings', // 6
  7: 'Main content', // 7
}

export const CONTENT_PROMPT_SIGNALS_TOOLTIPS = {
  'Key Highlights': 'The AI will write the Key Highlights of the main content.',
  'Brief Overview': 'The AI will write a brief overview of the main content.',
  'Bold Tag Total': 'The AI will bold as many terms as you ask it to bold.',
  'Italic Tag Total': 'The AI will italicize as many terms as you ask it to italicize.',
  'Form Total': 'The AI will put a placeholder in an area to put a form. The AI will not create any forms.',
  'Image File total': 'The AI will generate images for you.',
  'Table of content': 'A Table of Contents will be created based on your H2 and H3 subheadings.',
  'list': 'After the main content has been generated, you will be prompted to give the AI direction on what type of list or lists you need for your content.',
  'Table Total': 'After the main content has been generated, you will be prompted to give the AI direction on what type of table or tables you need for your content.',
  'Frequently Asked Questions': 'After the main content has been generated, you will be prompted to give the AI direction on what type of FAQs you need for your content.',
  'meta_description': 'The AI will write a meta description based on your title/topic. Meta descriptions typically appear in Google search results.',
  'intro_section': 'The AI write an introduction paragraph based on your title/topic.',
  'end_section': 'The AI will write a conclusion paragraph at the end based on your title/topic.',
  'Internal links': 'Step 1: Enter the link to your main page (the page you want to focus on).\nStep 2: Add links to two related pages that provide supporting content to your main page.\nWhen selecting links, focus on relevance and authority. For your Top-Level pages (key sales, product, or service pages), choose Supporting Pages that are closely related and add value to the topic of the Top-Level page. Supporting Pages might include detailed guides, related product pages, testimonials, or blog posts that strengthen the main page’s authority.\n\nIf you don’t have any Supporting Pages, simply leave the fields blank.\n\nAvoid linking to irrelevant pages like your Terms of Service, Privacy Policy, or any other content that doesn’t directly contribute to the subject matter or user intent for the Top-Level page.',
}

export const READABILITY_LEVEL_OPTIONS = [
  {
    value: "",
    text: "None",
    description: "Let AI decide a readability level based on the rest of configurations."
  },
  {
    value: "easy",
    text: "Easy",
    description: "Simple words and short sentences.Easily understood by an average 11-year-old student. Conversational and simple language, ideal for general consumers.",
    short_description: "Very easy to read (5th-6th grade)",
  },
  {
    value: "standard",
    text: "Standard",
    description: "Fairly easy to read. Standard, everyday language. Easily understood by 13- to 15-year-old students.",
    short_description: "Fairly easy to read (7th-9th grade)",
  },
  {
    value: "technical",
    text: "Technical",
    description: "More formal tone with slightly complex vocabulary, suited for educated readers. Fairly difficult to read.",
    short_description: "Fairly difficult to read (college level)",
  },
  {
    value: "professional",
    text: "Professional",
    description: "Advanced vocabulary and complex, jargon-heavy sentences. Very difficult to read. Best understood by university graduates.",
    short_description: "Very difficult to read (university level)",
  },
]

export const OPTIMIZATION_LEVEL_OPTIONS = [
  {
    value: "minimal",
    text: "Minimal",
    tooltip_html: "<div class='mb-2'><b>Simple & Light</b>: Just adds your main keyword in a few key spots (title, subheading, and once in the text).</div><div class='mb-2'><b>Best for</b>: Supporting articles or blog posts where light SEO is enough. Quick, clean, and natural.</div><div><b>POP Score</b>: Up to 65%</div>"
  },
  {
    value: "balanced",
    text: "Balanced",
    tooltip_html: "<div class='mb-2'><b>Smart & Natural</b>: Uses your main keyword, priority variations, and LSI keywords, plus Google NLP terms if they’re found in your POP page run.</div><div class='mb-2'><b>Best for</b>: New pages or content that needs solid SEO without sounding over-optimized — great for guides, collection pages, and evergreen content.</div><div><b>POP Score</b>: Around 75%</div>"
  },
  {
    value: "high",
    text: "High",
    tooltip_html: "<div class='mb-2'><b>Full Power SEO</b>: Maximizes SEO by placing your main keyword, variations, and Google-recognized terms across all sections.</div><div class='mb-2'><b>Best for</b>: Main product, category, or landing pages where you want to rank high and stay competitive.</div><div><b>POP Score</b>: Often above 80%</div>"
  },
  {
    value: "maximum",
    text: "Maximum",
    tooltip_html: "<div class='mb-2'><b>Maxed-Out SEO</b>: Pushes everything to the limit — max keyword usage, all variations, LSI terms, and Google NLPs crammed in for a perfect POP score.</div><div class='mb-2'><b>Best for</b>: Experiments or pages where hitting 100% SEO is the only goal — even if it compromises content quality.</div><div><b>POP Score</b>: 100%</div>"
  },
]